module.exports = __webpack_public_path__ + "static/img/wait-confirm.7a8dd4b4.png";